import type { FC } from 'react';
import { History } from 'lucide-react';

import { InlineNavigationButton } from '@/shared/ui';
import { TEST_IDS } from '@/testIds';

interface ActionHistoryLinkProps {
  onClick: () => void;
}

export const ActionHistoryLink: FC<ActionHistoryLinkProps> = ({ onClick }) => {
  return (
    <InlineNavigationButton
      onClick={onClick}
      testId={TEST_IDS.historyViewAllLink}
      before={<History size={16} aria-hidden="true" />}
    >
      View all history
    </InlineNavigationButton>
  );
};
